import * as React from 'react';
import MuiInputAdornment from '@mui/material/InputAdornment';
import { IInputAdornmentProps } from './input-adornment-props';

export const InputAdornment: React.FunctionComponent<IInputAdornmentProps> = props => {
  return <MuiInputAdornment {...props} />;
};
